<template>
  <section
    v-if="sectionTitle && sectionContent"
    class="about-me"
  >
    <div>
      <div>
        <div class="shape">
          <v-img-about-me-photo />
        </div>
      </div>
      <div>
        <article class="default-text">
          <!-- Render the about title -->
          <h2>{{ sectionTitle }}</h2>
          <div
            class="default-text"
            v-html="sectionContent"
          />

          <!-- A button for more information visible only when section is available -->
          <v-btn
            v-if="hasDetailSection"
            variant="flat"
            size="x-large"
            color="#d90d83"
            href="/o-mne"
          >
            Více informací
          </v-btn>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
// Vue Composition API functions for reactive state and side-effects
import { computed } from 'vue'

// Hook to access the microsite store, which holds site-wide data
import { useMicrositeStore } from '../../stores/useMicrositeStore'

// Custom image component for displaying the About Me photo
import VImgAboutMePhoto from '../v-img/VImgAboutMePhoto.vue'

// Initialize the microsite store instance
const store = useMicrositeStore()

/**
 * Computed property for the about section title.
 * Retrieves the title from the microsite store.
 *
 * @returns {string | undefined} The title of the about section.
 */
const sectionTitle = computed(() => store.microsite?.aboutTitle)

/**
 * Computed property for the about section HTML content.
 * Retrieves the HTML content from the microsite store.
 * Note: Ensure the HTML content is sanitized before rendering.
 *
 * @returns {string | undefined} The HTML content for the about section.
 */
const sectionContent = computed(() => store.microsite?.aboutContent)

const sectionDetailTitle1 = computed(() => store.microsite?.aboutMePageSection1Title)
const sectionDetailTitle2 = computed(() => store.microsite?.aboutMePageSection2Title)
const sectionDetailTitle3 = computed(() => store.microsite?.aboutMePageSection3Title)

const hasDetailSection = computed(() =>
  Boolean(
    sectionDetailTitle1.value ||
    sectionDetailTitle2.value ||
    sectionDetailTitle3.value
  )
)
/**
 * Computed property for the detail section HTML content.
 * Retrieves the detailed HTML content for the about page section.
 * Note: Ensure this HTML is safe to render.
 *
 * @returns {string | undefined} Detailed HTML content for the about section.
 */
const sectionDetailContent = computed(
  () => store.microsite?.aboutMePageSection1Content
)
</script>
